<div class="container center" *ngIf="loading">
  <div class="spinner-border text-primary"></div>
</div>

<div class="container" class="list-progetti" *ngIf="!loading">
  <!--PAGINATION-->
  <div class="row" *ngIf="paginate && this.listToDisplay.length > 0">
      <div class="col-12" *ngIf="pages <= 7 ">
          <span class="link pag-element" *ngIf="currentPage > 1" (click)="goToPage(currentPage - 1)">&lt;</span>
          <span class="link pag-element" [ngClass]="{'pag-active': currentPage == i}"
              *ngFor="let i of range(1, pages)" (click)="goToPage(i)">{{i}}</span>
          <span class="link pag-element" *ngIf="currentPage < pages" (click)="goToPage(currentPage + 1)">&gt;</span>
      </div>

      <div class="col-12" *ngIf="pages > 7">
          <span class="link pag-element" *ngIf="currentPage > 1" (click)="goToPage(currentPage - 1)">&lt;</span>
          <span class="link pag-element" [ngClass]="{'pag-active': currentPage == 1}" (click)="goToPage(1)">1</span>

          <span class="link pag-element" *ngIf="ellipsisLeft">...</span>
          <span class="link pag-element" [ngClass]="{'pag-active': currentPage == i}"
              *ngFor="let i of range(middleRangeStart, middleRangeEnd)" (click)="goToPage(i)">{{i}}</span>
          <span class="link pag-element" *ngIf="ellipsisRight">...</span>

          <span class="link pag-element" [ngClass]="{'pag-active': currentPage == pages}"
              (click)="goToPage(pages)">{{pages}}</span>
          <span class="link pag-element" *ngIf="currentPage < pages" (click)="goToPage(currentPage + 1)">&gt;</span>
      </div>
  </div>
  <!--PAGINATION-->

  <div class="row">
      <div class="col-12">
          <table class="table">
              <thead>
                  <tr>
                      <th *ngFor="let header of fields">
                          <span *ngIf="header.type != 'checkbox'">{{header.name}}</span>
                          <input *ngIf="header.type == 'checkbox'" class="" type="checkbox"
                              [(ngModel)]="selectAllCheckbox" (input)="checkAllItems()">
                          <!--<span *ngIf="sortableFields.includes(header.name)">^</span>-->
                      </th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngIf="this.listToDisplay.length == 0">
                      <td class="text-center" [attr.colspan]="fields.length">No Data</td>
                  </tr>
                  <tr *ngFor="let item of listToDisplay; index as i" [ngClass]="{'clickable-row': clickableRows}"
                      (click)="rowClicked(item)">
                      <td *ngFor="let field of fields; index as j">
                          <span class="string-field" *ngIf="field.type == 'string'">{{resolveObjectProperty(item,
                              field.property)}}</span>
                          <span *ngIf="field.type == 'datetime'">{{resolveObjectProperty(item, field.property) |
                              date:'d-MMM-y, h:mm:ss a'}}</span>
                          <span *ngIf="field.type == 'number'">{{resolveObjectProperty(item, field.property) | number:
                              '1.0-0'}}</span>
                          <span class="link" *ngIf="field.type == 'button' && checkCondition(item, field)"
                              (click)="buttonClicked(item, field.property)">{{field.name}}</span>
                          <input *ngIf="field.type == 'checkbox'" class="" type="checkbox"
                              [checked]="resolveObjectProperty(item, field.property)"
                              (change)="checkboxChanged(item)">
                          <div *ngIf="field.type == 'custom'">
                              <ng-container *ngIf="customFieldTemplateRef" [ngTemplateOutlet]="customFieldTemplateRef"
                                  [ngTemplateOutletContext]="{$implicit:i}">
                              </ng-container>
                          </div>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
  </div>

  <!--PAGINATION-->
  <div class="row" *ngIf="paginate && this.listToDisplay.length > 0">
      <div class="col-12" *ngIf="pages <= 7 && pages > 2">
          <span class="link pag-element" *ngIf="currentPage > 1" (click)="goToPage(currentPage - 1)">&lt;</span>
          <span class="link pag-element" [ngClass]="{'pag-active': currentPage == i}"
              *ngFor="let i of range(1, pages)" (click)="goToPage(i)">{{i}}</span>
          <span class="link pag-element" *ngIf="currentPage < pages" (click)="goToPage(currentPage + 1)">&gt;</span>
      </div>

      <div class="col-12" *ngIf="pages > 7">
          <span class="link pag-element" *ngIf="currentPage > 1" (click)="goToPage(currentPage - 1)">&lt;</span>
          <span class="link pag-element" [ngClass]="{'pag-active': currentPage == 1}" (click)="goToPage(1)">1</span>

          <span class="link pag-element" *ngIf="ellipsisLeft">...</span>
          <span class="link pag-element" [ngClass]="{'pag-active': currentPage == i}"
              *ngFor="let i of range(middleRangeStart, middleRangeEnd)" (click)="goToPage(i)">{{i}}</span>
          <span class="link pag-element" *ngIf="ellipsisRight">...</span>

          <span class="link pag-element" [ngClass]="{'pag-active': currentPage == pages}"
              (click)="goToPage(pages)">{{pages}}</span>
          <span class="link pag-element" *ngIf="currentPage < pages" (click)="goToPage(currentPage + 1)">&gt;</span>
      </div>
  </div>
  <!--PAGINATION-->
</div>